import React from 'react';
import { UserProvider } from './contexts/UserContext';
import { AuthInitialize } from './hooks/AuthInitialize';
import { MainPage } from './components/MainPage';
import { CursorGlow } from './components/CursorGlow';
import './App.css';

function App() {
  return (
    <UserProvider>
      <AuthInitialize />
      <CursorGlow />
      <MainPage />
    </UserProvider>
  );
}

export default App;